import { PageHeader } from '@shared/components';

import { TaskManagementNavigationTabs } from '../task-management-navigation-tabs';

export default function TaskManagementPageHeader() {
  return <PageHeader title='Task Management' tabs={<TaskManagementNavigationTabs />} />;
}
